/** Returns a CSS color string for an RFP margin value. Shared by ResultsTable and RegionalSummary. */
export function marginColor(margin: number): string {
    if (margin >= 2) return '#18ad4f';
    if (margin >= 0) return '#778169';
    return '#bb1919';
}

/** Straight-line distance in miles between two lat/lng points (Haversine formula). */
export function haversineMiles(lat1: number, lng1: number, lat2: number, lng2: number): number {
    const R = 3958.8; // Earth radius in miles
    const toRad = (d: number) => (d * Math.PI) / 180;
    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);
    const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
